<template>
	<div>
		<div class="row mb-8">
			<div class="col-md-4"><h1>{{ $t("attendance") }}</h1></div>
			<div class="col-md-8">
				<div class="float-right text-right form-inline">
                    <button class="btn btn-primary mr-2 float-lg-right float-left" :title="$t('advanced-search')"
                        @click="showadvancedsearch = !showadvancedsearch">
                            <b-icon-search />
                        </button>
					<span class="form-group"  v-if="$UserSession.hasPriv.call(this, 'TIMETABLE_ADMIN')
                    || $UserSession.hasPriv('PLACEMENT_MY_PLACEMENTS')
                    || $UserSession.hasPriv.call(this, 'TIMETABLE_ATTENDANCE') ">
						<label>{{ $t('date') }}</label>
						<input
							type="date"
							v-model="date"
							class="form-control ml-2"
							@change="getEvents()"
						>
					</span>
                    <button class="btn btn-primary ml-2" @click="selectStudent()" v-if="$UserSession.hasPriv.call(this, 'ATTENDANCE_AUDIT_LOG_VIEW')">{{ $t("audit-log") }}</button>
					<router-link class="btn btn-primary ml-2" to="/attendance/absences" v-if="$UserSession.hasPriv.call(this, 'RECORD_ABSENCE')">{{ $t("absences") }}</router-link>
				</div>
			</div>
		</div>
        <!-- Advanced search -->
        <div v-if="showadvancedsearch">
			<div class="row">
				<div class="col-md-2">
					<SelectInput
						v-model="search.programme"
						:label="$t('programme')"
						:options="$config.getValue('programmes')"
						optionLabel="Name"
						:nullable="true"
						:nullLabel="$t('all')"
					/>
				</div>
				<div class="col-md-1">
					<div class="form-group">
						<label>{{ $t("year") }}</label>
						<select class="form-control" v-model="search.Year"  :aria-label="$t('year')">
							<option :value="null">{{ $t("any") }}</option>
							<template v-if="search.programme">
								<option
								v-for="year in parseInt(search.programme.CourseLengthYears)"
								:key="year"
								:value="year"
								>{{ year }}
								</option>
								<option :value="parseInt(search.programme.CourseLengthYears) + 1">{{ $t('graduated') }}</option>
							</template>
						</select>
					</div>
				</div>
				<div class="col-md-2">
					<SelectInput
						v-model="search.GroupId"
						:label="$t('group')"
						:options="$config.getValue('groups')"
						:indexIsValue="true"
						:nullable="true"
						:nullLabel="$t('all')"
					/>
				</div>
                <div class="col-md-3">
                    <SelectInput
                        :label="$t('room')"
                        v-model="search.ttroom"
                        :options="this.ttrooms"
                        optionLabel="ttroom_name"
                        :nullable="true"
						:nullLabel="$t('all')"
                    />

                </div>
                <div class="col-md-4">
                    <TextInput
                        :label="$t('search')"
                        v-model="search.search"
                        :placeholder="$t('title')"
                    />

                </div>
			</div>
		</div>
		<div class="row">
			<div class="col-lg-12">
				<div class="list-group" v-if="filteredEvents.length">
					<div class="list-group-item" v-for="(event, index) in filteredEvents" :key="index" @click="viewEvent(event.ttevent_id)">
						<div class="d-flex flex-row align-items-center flex-wrap">
							<div class="mr-auto">
                                <strong v-if="event.formatted_title">{{ event.formatted_title }}</strong>
                                <br v-if="event.formatted_title"/>
								<em> {{ event.formatted_subtitle ? event.formatted_subtitle : event.ttevent_title }}</em> {{event.ttsessiontype_name}}
								<template v-if="event.ttevent_notes && event.ttevent_notes!=event.ttsessiontype_name">
									{{event.ttevent_notes}}
								</template>
								{{event.ttroom_name}}
								<br><strong>{{$datetime.timestampToTime(event.ttevent_datetimefrom, false)}} - {{$datetime.timestampToTime(event.ttevent_datetimeto, false)}} </strong>
                                <span v-for="(programme, pid) in generateCohorts(event.groups)" :key="pid">
                                    {{ programme.programme }}:
                                    <span v-for="(yearData, yid) in programme.years" :key="yid">
                                        {{ $t('year') }} {{ yearData.year }}, {{ $t('groups') }} {{ getGroupRange(yearData.groups) }}.
                                    </span>
                                </span>

							</div>
							<!--div class="d-flex flex-row flex-wrap align-items-center">
								<b-badge v-for="(group, i) in event.groups" :key="i" class="p-1 m-1 text-right">
                                    
									{{ $config.getProgrammeNameById(group.programme) }}<br>
									{{ $t('year-colon') + ' ' + group.year }},
									{{ $t('group-colon') + ' ' + $config.getGroupNameById(group.group) }}
								</b-badge>

							</div-->
						</div>
					</div>
				</div>

			</div>
		</div>

	</div>
</template>

<script>
export default {
	components: {},
	data: function() {
		return {
			date: this.$datetime.getDateFieldNowValue() ,
			events: [],
            showadvancedsearch: false,
            search:{},
            ttrooms:[],
            student: [],
		}
	},
	mounted() {
		this.getEvents();
	},
	methods: {
		getEvents(){
			this.$cfetch(`${this.$settings.APIBaseURL}/attendance/register/gettodayevents`, {
				data: {
					'date': this.date
				},
			}).then((res) => {
				if (res.status === "SUCCESS") {
					this.events = Object.values(res.result.events)

                    if(this.events.length > 5) {
                        this.showadvancedsearch = true;
                    }

                    //Uncomment if we are filtering by available programmes, years and groups
                    /*const programmes = new Set();
                    const years = new Set();
                    const groups = new Set();*/
                    const ttrooms = new Set();

                    this.events.forEach(obj => {
                        
                       /* const programme_id = obj['ProgrammeId'];

                        if (programme_id !== null && !programmes.has(programme_id)) {
                            programmes.add(programme_id);
                        }

                        const year = obj['Year'];

                        if (year !==null && !years.has(year)) {
                            years.add(year);
                        }

                        const group_id = obj['GroupId'];

                        if (group_id !== null && !groups.has(group_id)) {
                            groups.add(group_id);
                        }
                        */

                        // Clean title
                        const parts = obj['ttevent_title'] ? obj['ttevent_title'].split('//') : [];
                        obj['formatted_title'] = parts.length > 1 ? parts[1] : (obj['ttevent_title'] ? obj['ttevent_title'] : '');
                        obj['formatted_subtitle'] = parts.length > 1 ? parts[0] : '';

                        const ttroom_id = obj['ttroom_id'];
                        const ttroom_name = obj['ttroom_name'];
                        
                        if(ttroom_id !== null && ttroom_name !== null){
                            const roomObj = JSON.stringify({ ttroom_id: ttroom_id, ttroom_name: ttroom_name });
                            
                            if (!ttrooms.has(roomObj)) {
                                ttrooms.add(roomObj);
                            }
                        }
                    });

                    /*this.eventsData.programmes=Array.from(programmes);
                    this.eventsData.years=Array.from(years);
                    this.eventsData.groups=Array.from(groups);*/
                    this.ttrooms = Array.from(ttrooms).map(item =>JSON.parse(item))
				} else {
					if (res.error_message) {
						this.error = res.error_message;
					} else {
						this.error = this.$t("failed-load-timetable");
					}
				}
			});
		},
		viewEvent(ttevent_id){
			this.$router.push(`/attendance/register/${ttevent_id}`);
		},
        generateCohorts(groups){
            let programmes = new Map();
            groups.forEach(({ programme, year, group }) => {
                const prog_name = this.$config.getProgrammeNameById(programme)
                if (!programmes.has(prog_name)) {
                    programmes.set(prog_name, new Map());
                }
                const yearMap = programmes.get(prog_name);
                if (!yearMap.has(year)) {
                    yearMap.set(year, new Set());
                }
                yearMap.get(year).add(group);
            });
            return Array.from(programmes, ([programme, yearMap]) => ({
                programme,
                years: Array.from(yearMap, ([year, groupSet]) => ({
                    year,
                    groups: Array.from(groupSet)
                })).sort((a, b) => a.year - b.year)
            }));
        },
        getGroupRange(arr) {
            if (arr.length === 0) return '';
            
            const numbers = arr.map(Number).sort((a, b) => a - b);
            const result = [];
            
            let start = numbers[0];
            let end = numbers[0];
            
            for (let i = 1; i < numbers.length; i++) {
                if (numbers[i] === end + 1) {
                    end = numbers[i];
                } else {
                    if (start === end) {
                        result.push(start.toString());
                    } else {
                        result.push(`${start}-${end}`);
                    }
                    start = numbers[i];
                    end = numbers[i];
                }
            }
    
            if (start === end) {
                result.push(start.toString());
            } else {
                result.push(`${start}-${end}`);
            }
            
            return result.join(', ');
        },
        selectStudent(){
            const self = this;
            this.$users.getStudents.call(this).then((students) => {
                this.$store.commit("openModal", {
                    type: "selector",
                    title: this.$t("select-a-student"),
                    selectCallback: (selection) => {
                        self.$store.commit("closeModal");
                        if (selection && typeof selection === "object" && selection.id) {
                            self.$router.push(`/attendance/log/${selection.id}`);
                        }
                    },
                    data: students,
                    selected: this.student,
                    captionKey: "displayName",
                    subcaptionKey: "studentid",
                    studentSearchFilters: true
                });
            }).catch(error => {
                console.error("Failed to open student selector:", error);
            });
        }
	}, 
    computed:{
        filteredEvents(){
            let filtered = this.events;

            let prog = this.search.programme;
			let year = this.search.Year;
			let group = this.search.GroupId;
            let room = this.search.ttroom;
            let search = this.search.search ? this.search.search.toLowerCase() : null;

			if (prog) {
                console.log(prog)
				filtered = filtered.filter(item => item.groups.some(g => g.programme === prog.Id));
			}
			if (year) {
				filtered = filtered.filter(item => item.Year == year);
			}
			if (group) {
                filtered = filtered.filter(item => item.groups.some(g => g.group === group))
			}
            if(room){
                filtered = filtered.filter(item => item.ttroom_id == room.ttroom_id);
            }
            
            if(search) {
                filtered = filtered.filter(item => 
                    (item.ttevent_title && item.ttevent_title.toLowerCase().includes(search)) ||
                    (item.ttsessiontype_name && item.ttsessiontype_name.toLowerCase().includes(search)) ||
                    (item.ttevent_notes && item.ttevent_notes.toLowerCase().includes(search)) ||
                    (item.ttroom_name && item.ttroom_name.toLowerCase().includes(search))
                );
            }

			return filtered;
        }
    }
};
</script>
